import React, { FC } from 'react';

import styled, { useTheme } from 'styled-components';

import { SaveMyRewardsIcon } from '../icons/save-my-rewards';
import { RewardsStyleVariant, WithStyleVariant } from '../types';

const SaveMyRewardsIconContainer = styled.span`
  position: relative;
  bottom: 2px;
`;

export const BankMyRewardsLabel: FC<WithStyleVariant> = ({ variant }) => {
  const theme = useTheme();

  return (
    <SaveMyRewardsIconContainer>
      <SaveMyRewardsIcon
        aria-hidden
        fill={
          variant === RewardsStyleVariant.Secondary
            ? theme.token('icon-reversed')
            : theme.token('icon-active')
        }
      />
    </SaveMyRewardsIconContainer>
  );
};
